module.exports = __webpack_public_path__ + "static/img/GettyImages-537266160.194a05b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/GettyImages-537266160.jpg
// module id = CoSJ
// module chunks = 0